module.exports = __webpack_public_path__ + "img/avatar-none.6340f5d5.png";